import { mapGetters, mapActions } from 'vuex'
import siteTab from '@/components/tab'
import journal from '@/api/journal'
export default {
  components: {
    siteTab
  },
  data() {
    return {
      menus: [
        {
          name: 'General',
          href: '/system/journal-setting/general-setting',
          code: 'SYSTEM.JOURNAL_SETTING.GENERAL_SETTING'
        },
        {
          name: 'Country',
          href: '/system/journal-setting/country-setting',
          code: 'SYSTEM.JOURNAL_SETTING.COUNTRY_SETTING'
        },
        {
          name: 'Article Type',
          href: '/system/journal-setting/article-type-setting',
          code: 'SYSTEM.JOURNAL_SETTING.ARTICLE_TYPE_SETTING'
        }
      ],
      journals: [],
      currentJournal: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      language: 'getLanguage',
      journalId: 'getJournalId'
    })
  },
  watch: {
    user: {
      handler() {
        this.redict()
      },
      immediate: true
    },
    $route() {
      this.redict()
    }
  },
  mounted() {
    this.getJournal()
  },
  methods: {
    ...mapActions(['updateJournalId', 'updatePersonalJournalList']),
    async getJournal() {
      this.journals = await journal.userGet()
      const flag = this.journals.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.currentJournal = item.id
          return true
        }
      })
      if (!flag) {
        if (this.journals[0]) {
          this.currentJournal = this.journals[0].id
        }
        localStorage.setItem('journalId', this.currentJournal)
      }
      this.onJournalChange(this.currentJournal)
      this.updatePersonalJournalList(this.journals)
    },
    async onJournalChange(val) {
      localStorage.setItem('journalId', val)
      this.updateJournalId(val)
    },
    redict() {
      if (this.$route.path !== '/system/journal-setting') {
        return
      }
      this.menus.some(item => {
        if (this.user.codeList && this.user.codeList.includes(item.code)) {
          this.$router.replace(item.href)
          return true
        }
      })
    }
  }
}
